/**
 * @generated SignedSource<<5df00f5e9195b186885767fe3101a5c5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RemoveModelListModelInput = {
  modelId: string;
  modelListId: string;
};
export type MainRemoveModelListModelMutation$variables = {
  input: RemoveModelListModelInput;
};
export type MainRemoveModelListModelMutation$data = {
  readonly removeModelListModel: {
    readonly modelList: {
      readonly id: string;
    };
  };
};
export type MainRemoveModelListModelMutation = {
  response: MainRemoveModelListModelMutation$data;
  variables: MainRemoveModelListModelMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RemoveModelListModelPayload",
    "kind": "LinkedField",
    "name": "removeModelListModel",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ModelList",
        "kind": "LinkedField",
        "name": "modelList",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MainRemoveModelListModelMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MainRemoveModelListModelMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "0e261eff4eb4a46ddbf01ac69f13bf79",
    "id": null,
    "metadata": {},
    "name": "MainRemoveModelListModelMutation",
    "operationKind": "mutation",
    "text": "mutation MainRemoveModelListModelMutation(\n  $input: RemoveModelListModelInput!\n) {\n  removeModelListModel(input: $input) {\n    modelList {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "38b96b0711c05233417c271fcf804984";

export default node;
